import UserInfo from "../../component/userinfo/UserInfo";
import LangSwitcher from "../../component/langswitcher/LangSwitcher";
import DeviceMetricCards from "../../component/devicemetriccard/DeviceMetricCards";
import Notification from "../../component/notification/Notification";
import Support from "../../component/support/Support";
import { ReactComponent as LogoutIcon } from '../../assets/images/logout-icon.svg';
import { ReactComponent as ShopPurpleIcon } from '../../assets/images/shop-icon-purple.svg';
import { AuthService } from "../../service/AuthService";
import { useNavigate } from "react-router-dom";
import { AccessLevel, useAuth } from "../../hook/useAuth";
import { useEffect, useMemo, useState } from "react";
import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";

const MerchantTopBarInfo = ({ merchant, accessLevel }) => {
    if (accessLevel !== AccessLevel.MERCHANT || !merchant) {
        return null;
    }

    const name = merchant.name;
    const code = merchant.merchantCode;

    if (!name && !code) {
        return null;
    }

    return (
        <div className="top-bar-merchant">
            <ShopPurpleIcon className="merchant-icon" />
            <div className="merchant-text">
                <span className="merchant-name">{name}</span>
                {code && <span className="merchant-code"> (ID: {code})</span>}
            </div>
        </div>
    );
};

const TopBar = () => {
    const { getAccessLevel, isUserInAnyRole, getMerchant } = useAuth();
    const navigate = useNavigate();
    const [accessLevel, setAccessLevel] = useState(null);
    const { t } = useTranslation();
    const merchant = useMemo(() => getMerchant(), [getMerchant]);
    useEffect(() => {
        setAccessLevel(getAccessLevel());
    }, [getAccessLevel]);

    const isDeviceMetricsVisible = useMemo(
        () => isUserInAnyRole(['DEVICES_READ', 'DEVICES_WRITE']) && accessLevel === AccessLevel.MERCHANT,
        [isUserInAnyRole, accessLevel]
    );

    return (
        <div className='flex flex-column pl-3 pr-3 mr-0 bg-white'>
            <div className='top-bar'>
                <div className="top-bar-inner">
                    <MerchantTopBarInfo merchant={merchant} accessLevel={accessLevel} />
                    <div className="top-bar-right">
                        {/* <Notification value={12}/> */}
                        <Support />
                        <UserInfo />
                        <LogoutIcon className='cursor-pointer' id='logout-icon' onClick={ e => {
                            AuthService.logout(true, false, navigate);
                        }}/>
                        <Tooltip target="#logout-icon" content={t('topBar.logout')} />
                        <LangSwitcher />
                    </div>
                </div>
            </div>
            {isDeviceMetricsVisible && <DeviceMetricCards />}
            
        </div>
    )
}

export default TopBar;